<app-chat [chatType]="chatType.ASSISTANT"
          description="This File chat is configured to answer your questions regarding the documents you have uploaded."
></app-chat>
